import { TopPage as _TopPage } from '../pages/TopPage';
import { ContentPage as _ContentPage} from '../pages/ContentPage';

export namespace Pages
{
	export const TopPage = _TopPage;
	export const ContentPage = _ContentPage;
}